import React, { useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import { logout } from '../../utils/auth';
import CoordinatorDashboardHome from './CoordinatorDashboardHome';
import CoordinatorPlacementDrives from './CoordinatorPlacementDrives';
import CoordinatorVacancies from './CoordinatorVacancies';
import CoordinatorApplications from './CoordinatorApplications';
import CoordinatorPendingStudents from './CoordinatorPendingStudents';
import Notifications from '../Notifications';
import './CoordinatorDashboard.css';

function CoordinatorDashboard() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const menuItems = [
    { path: '', label: 'Dashboard', icon: '📊' },
    { path: 'notifications', label: 'Notifications', icon: '🔔' },
    { path: 'pending-students', label: 'Pending Students', icon: '👥' },
    { path: 'placement-drives', label: 'Placement Drives', icon: '📋' },
    { path: 'vacancies', label: 'Vacancies', icon: '💼' },
    { path: 'applications', label: 'Applications', icon: '📄' },
  ];

  const handleLogout = async () => {
    await authService.logout();
    logout();
    navigate('/login');
    window.location.reload();
  };

  return (
    <div className="coordinator-dashboard">
      <div className={`coordinator-sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>Coordinator Portal</h2>
          <button className="sidebar-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            {isSidebarOpen ? '◀' : '▶'}
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path || 'dashboard'}
              to={item.path}
              end={item.path === ''}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {isSidebarOpen && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            {isSidebarOpen && <span>Logout</span>}
            <span className="logout-icon">🚪</span>
          </button>
        </div>
      </div>
      <div className="coordinator-content">
        <Routes>
          <Route path="" element={<CoordinatorDashboardHome />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="pending-students" element={<CoordinatorPendingStudents />} />
          <Route path="placement-drives" element={<CoordinatorPlacementDrives />} />
          <Route path="vacancies" element={<CoordinatorVacancies />} />
          <Route path="applications" element={<CoordinatorApplications />} />
        </Routes>
      </div>
    </div>
  );
}

export default CoordinatorDashboard;
